export const CHECK_IN_PHRASES = [
  { key: 'two_tree', template: 'Having a couple two tree at the local watering hole at {bar}.' },
  { key: 'bellied_up', template: 'Bellied up at {bar}. First round is spoken for.' },
  { key: 'last_call_later', template: 'Checked in at {bar}. Last call can wait.' },
  { key: 'old_style', template: 'Pouring one out... into a glass... at {bar}.' },
  { key: 'stool_saved', template: 'Stool saved at {bar}. Come say hi.' },
  { key: 'tap_running', template: 'The tap is running at {bar} and so am I. To the bar.' },
  { key: 'neighborhood_pint', template: 'Grabbing a neighborhood pint at {bar}.' },
  { key: 'cash_only_energy', template: 'Cash-only energy at {bar}. Who\'s around?' },
];

export function formatCheckInMessage(phrase, barName) {
  const template = phrase?.template || CHECK_IN_PHRASES[0].template;
  return template.replace('{bar}', barName || 'the bar');
}

export function pickCheckInPhrase(index) {
  const safeIndex = Number.isFinite(index)
    ? Math.abs(Math.floor(index)) % CHECK_IN_PHRASES.length
    : Math.floor(Math.random() * CHECK_IN_PHRASES.length);
  return CHECK_IN_PHRASES[safeIndex];
}

export function canCheckInAtBar(userRating) {
  return Boolean(userRating && userRating.overall > 0);
}
